import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontRightUpperControlArmProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function FrontRightUpperControlArm(props: FrontRightUpperControlArmProps) {
  return (
    <svg
      width="68"
      height="48"
      viewBox="0 0 68 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 86, left: 247}}
      onClick={props.onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39 7.68555C43.6604 9.33311 47 13.7754 47 19C47 20.9561 46.5323 22.803 45.7021 24.4346L65 47H55L40 29.9121C38.4237 30.6734 36.8679 31 35 31C33.2156 31 31.5221 30.6107 30 29.9121L15 47H5L23.7393 25H7C3.68633 25 1 22.3137 1 19C1 15.6863 3.68633 13 7 13H24.6094C26.029 10.5469 28.29 8.64365 31 7.68555V1H39V7.68555ZM24.0273 24.6611L24.2695 24.3779C24.2052 24.2499 24.1438 24.1199 24.084 23.9893L24.0273 24.6611Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M39.0001 7V1H31.0001V7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="7.00009"
        cy="19"
        r="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M25.0001 13H7.00009C3.68638 13 1.00009 15.6863 1.00009 19C1.00009 22.3137 3.68638 25 7.00009 25H24.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M55.0001 46.9997L40.0001 29.9118C38.4237 30.6732 36.868 31 35.0001 31C33.2157 31 31.5222 30.6105 30.0001 29.9119L15.0001 46.9998L5.00009 47L24.2695 24.3776C23.4573 22.76 23.0001 20.9334 23.0001 19C23.0001 12.3726 28.3727 7 35.0001 7C41.6275 7 47.0001 12.3726 47.0001 19C47.0001 20.9562 46.532 22.8031 45.7017 24.4348L65.0001 46.9997H55.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M43.0001 19L39.0001 25.9282L31.0001 25.9282L27.0001 19L31.0001 12.0718L39.0001 12.0718L43.0001 19Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="35.0001"
        cy="19"
        r="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
